(function () {
  'use strict';

  var STORAGE_STATE = 'parael_spin_result_v1';
  var STORAGE_COMPLETIONS = 'parael_spin_completions_v1';
  var SPIN_DURATION_MS = 6200;
  var CELEBRATE_DURATION_MS = 1800;

  var WIN_PRIZES = {
    '15': { id: '15', label: '15%', code: 'PARAEL15', tag: 'spin-15', weight: 96 },
    envio: { id: 'envio', label: 'ENVÍO GRATIS', code: 'PARAEL-ENVIO', tag: 'spin-envio', weight: 2 },
    '10': { id: '10', label: '10%', code: 'PARAEL10', tag: 'spin-10', weight: 1 },
    '5': { id: '5', label: '5%', code: 'PARAEL5', tag: 'spin-5', weight: 1 },
  };

  var WHEEL_SEGMENTS = [
    { type: 'lose', label: 'NADA', color: '#1A1A1D', textColor: '#666666' },
    { type: 'win', prizeId: '5', label: '5%', color: '#F5CB5C', textColor: '#000000' },
    { type: 'lose', label: 'NADA', color: '#0B0B0C', textColor: '#666666' },
    { type: 'win', prizeId: '10', label: '10%', color: '#1A1A1D', textColor: '#FFFFFF' },
    { type: 'win', prizeId: '5', label: '5%', color: '#F5CB5C', textColor: '#000000' },
    { type: 'win', prizeId: 'envio', lines: ['ENVÍO', 'GRATIS'], color: '#0B0B0C', textColor: '#FFFFFF', fontSize: 6 },
    { type: 'lose', label: 'NADA', color: '#1A1A1D', textColor: '#666666' },
    { type: 'win', prizeId: '10', label: '10%', color: '#F5CB5C', textColor: '#000000' },
    { type: 'win', prizeId: '15', label: '15%', color: '#0B0B0C', textColor: '#FFFFFF' },
  ];

  var COPY_SVG =
    '<svg class="spin-wheel__copy-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect width="14" height="14" x="8" y="8" rx="2" ry="2" stroke="currentColor" stroke-width="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" stroke="currentColor" stroke-width="2"/></svg>';
  var CHECK_SVG =
    '<svg class="spin-wheel__copy-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 6 9 17l-5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function isHomePage() {
    if (document.body.classList.contains('template-index')) return true;
    var path = window.location.pathname.replace(/\/+$/, '') || '/';
    return path === '/';
  }

  function readJson(key, fallback) {
    try {
      var raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function writeJson(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      /* ignore */
    }
  }

  function isCompleted(state) {
    return !!(state && state.stage === 'done' && state.email && state.prizeId);
  }

  function hasSpunBefore(state) {
    return !!(state && state.spun && state.prizeId);
  }

  function getPrizeById(id) {
    return WIN_PRIZES[id] || null;
  }

  function pickWinPrize() {
    var keys = Object.keys(WIN_PRIZES);
    var total = 0;
    var i;
    var r;

    for (i = 0; i < keys.length; i++) total += WIN_PRIZES[keys[i]].weight;
    r = Math.random() * total;

    for (i = 0; i < keys.length; i++) {
      r -= WIN_PRIZES[keys[i]].weight;
      if (r <= 0) return WIN_PRIZES[keys[i]];
    }

    return WIN_PRIZES['15'];
  }

  function getSegmentIndicesForPrize(prizeId) {
    var out = [];
    var i;

    for (i = 0; i < WHEEL_SEGMENTS.length; i++) {
      if (WHEEL_SEGMENTS[i].type === 'win' && WHEEL_SEGMENTS[i].prizeId === prizeId) {
        out.push(i);
      }
    }

    return out.length ? out : [0];
  }

  function buildWheelSvg(svg) {
    if (!svg) return;

    var segmentAngle = 360 / WHEEL_SEGMENTS.length;
    var i;
    var seg;
    var start;
    var end;
    var x1;
    var y1;
    var x2;
    var y2;
    var large;
    var path;
    var midAngle;
    var tx;
    var ty;
    var rot;
    var g;
    var pathEl;
    var textEl;

    svg.innerHTML = '';

    for (i = 0; i < WHEEL_SEGMENTS.length; i++) {
      seg = WHEEL_SEGMENTS[i];
      start = (i * segmentAngle - 90) * (Math.PI / 180);
      end = ((i + 1) * segmentAngle - 90) * (Math.PI / 180);
      x1 = 100 + 100 * Math.cos(start);
      y1 = 100 + 100 * Math.sin(start);
      x2 = 100 + 100 * Math.cos(end);
      y2 = 100 + 100 * Math.sin(end);
      large = segmentAngle > 180 ? 1 : 0;
      path = 'M100,100 L' + x1 + ',' + y1 + ' A100,100 0 ' + large + ' 1 ' + x2 + ',' + y2 + ' Z';
      midAngle = (i * segmentAngle + segmentAngle / 2 - 90) * (Math.PI / 180);
      tx = 100 + 62 * Math.cos(midAngle);
      ty = 100 + 62 * Math.sin(midAngle);
      rot = i * segmentAngle + segmentAngle / 2;

      g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      pathEl = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      pathEl.setAttribute('d', path);
      pathEl.setAttribute('fill', seg.color);
      pathEl.setAttribute('stroke', '#1f1f22');
      pathEl.setAttribute('stroke-width', '0.5');
      g.appendChild(pathEl);

      textEl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      textEl.setAttribute('x', String(tx));
      textEl.setAttribute('y', String(ty));
      textEl.setAttribute('fill', seg.textColor);
      textEl.setAttribute('font-size', String(seg.fontSize || 8));
      textEl.setAttribute('font-weight', '700');
      textEl.setAttribute('text-anchor', 'middle');
      textEl.setAttribute('dominant-baseline', 'middle');
      textEl.setAttribute('letter-spacing', '0.3');
      textEl.setAttribute('transform', 'rotate(' + rot + ', ' + tx + ', ' + ty + ')');

      if (seg.lines && seg.lines.length) {
        seg.lines.forEach(function (line, lineIndex) {
          var tspan = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
          tspan.setAttribute('x', String(tx));
          tspan.setAttribute('dy', lineIndex === 0 ? '-0.55em' : '1.1em');
          tspan.textContent = line;
          textEl.appendChild(tspan);
        });
      } else {
        textEl.textContent = seg.label;
      }

      g.appendChild(textEl);
      svg.appendChild(g);
    }
  }

  function spawnEmojis(container) {
    if (!container) return;

    var emojis = ['🎉', '✨', '🎁', '💰', '🏆', '🔥', '💎', '🌟', '⚡', '🍾'];
    var i;
    var span;

    container.innerHTML = '';

    for (i = 0; i < 18; i++) {
      span = document.createElement('span');
      span.textContent = emojis[i % emojis.length];
      span.style.left = 5 + ((i * 5.2) % 90) + '%';
      span.style.fontSize = 16 + (i % 3) * 6 + 'px';
      span.style.animation = 'spin-fall-emoji ' + (1.8 + (i % 4) * 0.35) + 's ease-in forwards';
      span.style.animationDelay = (i % 7) * 0.12 + 's';
      span.style.position = 'absolute';
      span.style.top = '0';
      span.style.lineHeight = '1';
      container.appendChild(span);
    }
  }

  function spawnConfetti(container) {
    if (!container) return;

    var i;
    var span;

    container.innerHTML = '';

    for (i = 0; i < 28; i++) {
      span = document.createElement('span');
      span.style.position = 'absolute';
      span.style.left = '50%';
      span.style.top = '50%';
      span.style.width = '6px';
      span.style.height = '6px';
      span.style.borderRadius = '2px';
      span.style.backgroundColor = i % 2 ? '#F5CB5C' : '#FFFFFF';
      span.style.setProperty('--angle', (i * 360) / 28 + 'deg');
      span.style.setProperty('--dist', 90 + (i % 5) * 14 + 'px');
      span.style.animation = 'spin-confetti-burst 1.4s cubic-bezier(0.16, 1, 0.3, 1) forwards';
      span.style.animationDelay = (i % 6) * 0.04 + 's';
      container.appendChild(span);
    }
  }

  function portalToBody(el) {
    if (el && el.parentElement !== document.body) {
      document.body.appendChild(el);
    }
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function responseIndicatesDuplicate(html) {
    var lower = (html || '').toLowerCase();
    return (
      lower.indexOf('already been taken') !== -1 ||
      lower.indexOf('already subscribed') !== -1 ||
      lower.indexOf('ya está') !== -1 ||
      lower.indexOf('ya has participado') !== -1 ||
      lower.indexOf('already exists') !== -1 ||
      lower.indexOf('ya está registrado') !== -1 ||
      lower.indexOf('ya se ha utilizado') !== -1 ||
      lower.indexOf('correo electrónico ya') !== -1 ||
      lower.indexOf('email is invalid') !== -1 ||
      lower.indexOf('has already been') !== -1
    );
  }

  function parseShopifyFormResponse(html) {
    var lower = (html || '').toLowerCase();

    if (lower.indexOf('customer_posted=true') !== -1 || lower.indexOf('newsletter-form__message--success') !== -1) {
      return { ok: true };
    }

    if (responseIndicatesDuplicate(html)) {
      return { ok: false, reason: 'duplicate' };
    }

    if (lower.indexOf('captcha') !== -1 && lower.indexOf('challenge') !== -1) {
      return { ok: false, reason: 'captcha' };
    }

    return { ok: true };
  }

  function protectShopifyForm(form) {
    if (!form || !window.Shopify || !window.Shopify.captcha) return;
    if (typeof window.Shopify.captcha.protect !== 'function') return;

    try {
      window.Shopify.captcha.protect(form);
    } catch (e) {
      /* captcha optional */
    }
  }

  function buildCustomerTags(prize) {
    return 'newsletter, spin-participo, ' + prize.tag + ', spin-prize-' + prize.id + ', spin-code-' + prize.code;
  }

  function getSpinCheckUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + 'apps/spin/check';
    }
    return '/apps/spin/check';
  }

  function init() {
    var app = document.getElementById('spin-wheel-app');
    if (!app || !isHomePage()) return;

    var backdrop = app.querySelector('.spin-wheel__backdrop');
    var dialog = backdrop ? backdrop.querySelector('.spin-wheel__dialog') : null;
    var tab = app.querySelector('.spin-wheel__tab');

    if (!backdrop || !dialog || !tab) return;

    var els = {
      wheelBlock: dialog.querySelector('[data-wheel-block]'),
      wheelSvg: dialog.querySelector('.spin-wheel__wheel-svg'),
      emojiLayer: dialog.querySelector('.spin-wheel__emoji-layer'),
      wheelConfetti: dialog.querySelector('.spin-wheel__wheel-confetti'),
      title: dialog.querySelector('.spin-wheel__title'),
      subtitle: dialog.querySelector('.spin-wheel__subtitle'),
      spinBtn: dialog.querySelector('.spin-wheel__spin-btn'),
      celebrateText: dialog.querySelector('.spin-wheel__celebrate-text'),
      shopifyForm: dialog.querySelector('#SpinWheelCustomerForm'),
      submitBtn: dialog.querySelector('[data-spin-submit]'),
      emailInput: document.getElementById('spin-wheel-email'),
      error: dialog.querySelector('.spin-wheel__error'),
      consentInput: dialog.querySelector('.spin-wheel__consent-input'),
      copyBtn: dialog.querySelector('.spin-wheel__copy-btn'),
      doneBtn: dialog.querySelector('.spin-wheel__done-btn'),
      prizeValueEmail: dialog.querySelector('[data-prize-value-email]'),
      prizeValueDone: dialog.querySelector('[data-prize-value-done]'),
      codeValue: dialog.querySelector('.spin-wheel__code-value'),
      emailSent: dialog.querySelector('.spin-wheel__email-sent'),
      panelSpin: dialog.querySelector('[data-panel="spin"]'),
      panelCelebrate: dialog.querySelector('[data-panel="celebrate"]'),
      panelEmail: dialog.querySelector('[data-panel="email"]'),
      panelDone: dialog.querySelector('[data-panel="done"]'),
      closeButtons: dialog.querySelectorAll('.spin-wheel__dialog-close, .spin-wheel__close-inline'),
    };

    if (els.shopifyForm) {
      els.shopifyForm.setAttribute('data-nocaptcha', 'true');
      els.shopifyForm.dataset.nocaptcha = 'true';
    }

    portalToBody(backdrop);
    portalToBody(tab);

    var headingDefault = app.getAttribute('data-heading') || 'Prueba tu suerte';
    var subheadingDefault = app.getAttribute('data-subheading') || 'Gira y descubre tu premio exclusivo.';
    var delay = parseInt(app.getAttribute('data-delay'), 10) || 4;

    var spinning = false;
    var prize = null;
    var baseRotation = 0;
    var openedOnce = false;
    var currentStage = 'spin';
    var hasSpun = false;
    var savedState = readJson(STORAGE_STATE, null);
    var dialogIsOpen = false;
    var doneHeaderMode = 'success';

    buildWheelSvg(els.wheelSvg);
    if (els.title) els.title.textContent = headingDefault;
    if (els.subtitle) els.subtitle.textContent = subheadingDefault;

    function getCompletionForEmail(email) {
      var map = readJson(STORAGE_COMPLETIONS, {});
      return map[(email || '').toLowerCase()] || null;
    }

    function saveCompletion(email, data, forceUpdate) {
      var key = (email || '').toLowerCase();
      var map = readJson(STORAGE_COMPLETIONS, {});
      if (map[key] && !forceUpdate) return false;
      map[key] = data;
      writeJson(STORAGE_COMPLETIONS, map);
      return true;
    }

    function persistState(stage, email) {
      if (!prize) return;

      var next = {
        prizeId: prize.id,
        code: prize.code,
        rotation: baseRotation,
        stage: stage,
        spun: true,
      };

      if (email) next.email = email;
      writeJson(STORAGE_STATE, next);
      savedState = next;
    }

    function setHeader(stage) {
      if (!els.title || !els.subtitle) return;

      if (stage === 'done') {
        if (doneHeaderMode === 'already') {
          els.title.textContent = 'Hemos detectado que ya habías jugado antes';
          els.subtitle.textContent = 'El premio que te corresponde es:';
          return;
        }
        els.title.textContent = '¡Todo listo!';
        els.subtitle.textContent = 'Revisa tu correo — y usa tu código aquí abajo.';
        return;
      }

      if (stage === 'email') {
        els.title.textContent = '¿Dónde te lo enviamos?';
        els.subtitle.textContent = 'Te enviaremos tu código por email para que no lo pierdas.';
        return;
      }

      els.title.textContent = headingDefault;
      els.subtitle.textContent = subheadingDefault;
    }

    function setStage(stage) {
      currentStage = stage;
      setHeader(stage);

      if (els.panelSpin) els.panelSpin.hidden = stage !== 'spin' || hasSpun;
      if (els.panelCelebrate) els.panelCelebrate.hidden = stage !== 'celebrate';
      if (els.panelEmail) els.panelEmail.hidden = stage !== 'email';
      if (els.panelDone) els.panelDone.hidden = stage !== 'done';
      if (els.wheelBlock) els.wheelBlock.hidden = stage === 'email' || stage === 'done';

      if (stage === 'email' || stage === 'done') {
        dialog.classList.add('is-wide');
      } else {
        dialog.classList.remove('is-wide');
      }

      if (stage === 'email' && els.shopifyForm) {
        els.shopifyForm.setAttribute('data-nocaptcha', 'true');
        els.shopifyForm.dataset.nocaptcha = 'true';
      }
    }

    function updateTabVisibility() {
      tab.hidden = dialogIsOpen;
    }

    function openDialog() {
      dialogIsOpen = true;
      backdrop.setAttribute('aria-hidden', 'false');
      dialog.setAttribute('aria-hidden', 'false');

      requestAnimationFrame(function () {
        backdrop.classList.add('is-visible');
        dialog.classList.add('is-visible');
      });

      document.body.classList.add('spin-wheel-lock');
      app.setAttribute('aria-hidden', 'false');
      updateTabVisibility();
      setStage(currentStage);
    }

    function closeDialog() {
      dialogIsOpen = false;
      backdrop.classList.remove('is-visible');
      dialog.classList.remove('is-visible');
      backdrop.setAttribute('aria-hidden', 'true');
      dialog.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('spin-wheel-lock');
      updateTabVisibility();
    }

    function renderDoneContent(email) {
      if (!prize) return;
      if (els.prizeValueDone) els.prizeValueDone.textContent = prize.label;
      if (els.codeValue) els.codeValue.textContent = prize.code;
      if (els.emailSent) {
        if (doneHeaderMode === 'already') {
          els.emailSent.innerHTML =
            'Este premio ya estaba asociado a <strong>' + email + '</strong>.';
        } else {
          els.emailSent.innerHTML = 'Se ha enviado una copia a <strong>' + email + '</strong>.';
        }
      }
    }

    function showError(message) {
      if (!els.error) return;
      els.error.textContent = message;
      els.error.hidden = false;
    }

    function clearError() {
      if (!els.error) return;
      els.error.textContent = '';
      els.error.hidden = true;
    }

    function prizeFromCompletion(prev) {
      if (!prev) return null;
      return (
        getPrizeById(prev.prizeId) || {
          id: prev.prizeId,
          label: prev.label || prev.prizeId,
          code: prev.code,
          tag: prev.tag || '',
        }
      );
    }

    function showDone(email, already) {
      if (!already) {
        var existing = getCompletionForEmail(email);
        if (existing) {
          prize = prizeFromCompletion(existing);
          showDone(email, true);
          return;
        }
      }

      doneHeaderMode = already ? 'already' : 'success';
      renderDoneContent(email);
      setStage('done');

      if (!already) {
        persistState('done', email);
      }

      saveCompletion(
        email,
        {
          prizeId: prize.id,
          label: prize.label,
          code: prize.code,
          tag: prize.tag,
        },
        already
      );

      if (!dialogIsOpen) openDialog();
    }

    function showAlreadyParticipated(email) {
      var prev = getCompletionForEmail(email);

      if (!prev && isCompleted(savedState) && savedState.email === email) {
        prev = {
          prizeId: savedState.prizeId,
          code: savedState.code,
          label: getPrizeById(savedState.prizeId)
            ? getPrizeById(savedState.prizeId).label
            : savedState.prizeId,
        };
      }

      if (!prev) {
        showError('Este email ya participó en la ruleta. Revisa tu correo para ver tu código.');
        return;
      }

      clearError();
      prize = prizeFromCompletion(prev);
      showDone(email, true);
    }

    function showCelebrate(targetPrize) {
      if (els.celebrateText) {
        els.celebrateText.textContent = '¡Has ganado ' + targetPrize.label + '!';
      }

      setStage('celebrate');
      spawnEmojis(els.emojiLayer);
      spawnConfetti(els.wheelConfetti);

      window.setTimeout(function () {
        if (els.prizeValueEmail) els.prizeValueEmail.textContent = targetPrize.label;
        setStage('email');
        persistState('email');
        if (els.emailInput) els.emailInput.focus();
      }, CELEBRATE_DURATION_MS);
    }

    function handleSpin() {
      if (spinning || hasSpun || !els.spinBtn || !els.wheelSvg) return;

      spinning = true;
      els.spinBtn.disabled = true;
      els.spinBtn.textContent = 'Girando…';

      prize = pickWinPrize();
      hasSpun = true;

      var indices = getSegmentIndicesForPrize(prize.id);
      var idx = indices[Math.floor(Math.random() * indices.length)];
      var segmentAngle = 360 / WHEEL_SEGMENTS.length;
      var segmentCenter = idx * segmentAngle + segmentAngle / 2;
      var finalRotation = baseRotation + 7 * 360 + (360 - segmentCenter);

      baseRotation = finalRotation;
      els.wheelSvg.classList.add('is-spinning');
      els.wheelSvg.style.transform = 'rotate(' + finalRotation + 'deg)';
      persistState('celebrate');

      window.setTimeout(function () {
        spinning = false;
        els.spinBtn.textContent = 'Girar la ruleta';
        showCelebrate(prize);
      }, SPIN_DURATION_MS);
    }

    function submitEmail(email) {
      if (!prize) return Promise.resolve({ ok: false, reason: 'form' });

      if (els.emailInput) els.emailInput.value = email;

      return fetch(getSpinCheckUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          prizeId: prize.id,
          label: prize.label,
          code: prize.code,
          tag: prize.tag,
        }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok || !data || !data.ok) {
              return {
                ok: false,
                reason: (data && data.reason) || 'error',
              };
            }

            if (data.prize) {
              prize = {
                id: data.prize.id,
                label: data.prize.label,
                code: data.prize.code,
                tag: data.prize.tag || prize.tag,
              };
            }

            return {
              ok: true,
              alreadyParticipated: !!data.alreadyParticipated,
              prize: data.prize || prize,
            };
          });
        })
        .catch(function () {
          return { ok: false, reason: 'network' };
        });
    }

    function handleEmailClaim() {
      clearError();

      var email = els.emailInput ? (els.emailInput.value || '').trim().toLowerCase() : '';

      if (!isValidEmail(email)) {
        showError('Introduce una dirección de email válida.');
        return;
      }

      if (!els.consentInput || !els.consentInput.checked) {
        showError('Debes aceptar recibir emails de marketing para reclamar tu premio.');
        return;
      }

      if (getCompletionForEmail(email)) {
        showAlreadyParticipated(email);
        return;
      }

      if (isCompleted(savedState) && savedState.email === email) {
        showAlreadyParticipated(email);
        return;
      }

      if (els.submitBtn) {
        els.submitBtn.disabled = true;
        els.submitBtn.textContent = 'Enviando…';
      }

      submitEmail(email)
        .then(function (result) {
          if (!result || !result.ok) {
            if (result && result.reason === 'rate_limit') {
              showError('Demasiados intentos. Espera unos minutos e inténtalo de nuevo.');
              return;
            }
            showError('No se pudo registrar tu email. Inténtalo de nuevo.');
            return;
          }

          if (result.alreadyParticipated) {
            if (result.prize) {
              prize = {
                id: result.prize.id,
                label: result.prize.label,
                code: result.prize.code,
                tag: result.prize.tag || (prize && prize.tag) || '',
              };
            }
            showDone(email, true);
            return;
          }

          showDone(email, false);
        })
        .catch(function () {
          showError('No se pudo registrar tu email. Inténtalo de nuevo.');
        })
        .finally(function () {
          if (els.submitBtn) {
            els.submitBtn.disabled = false;
            els.submitBtn.textContent = 'Reclamar mi premio';
          }
        });
    }

    function restoreFromState() {
      if (!savedState || !savedState.prizeId) return false;

      prize = getPrizeById(savedState.prizeId);
      if (!prize) return false;

      hasSpun = true;
      baseRotation = savedState.rotation || 0;

      if (els.wheelSvg) {
        els.wheelSvg.style.transform = 'rotate(' + baseRotation + 'deg)';
      }

      if (isCompleted(savedState)) {
        currentStage = 'done';
        doneHeaderMode = 'success';
        renderDoneContent(savedState.email);
        setStage('done');
        return true;
      }

      currentStage = savedState.stage === 'celebrate' ? 'email' : savedState.stage || 'email';

      if (els.prizeValueEmail) els.prizeValueEmail.textContent = prize.label;
      setStage(currentStage === 'done' ? 'email' : currentStage);

      if (els.spinBtn) els.spinBtn.disabled = true;
      return true;
    }

    function scheduleOpen() {
      if (openedOnce || hasSpunBefore(savedState) || isCompleted(savedState)) return;

      window.setTimeout(function () {
        openedOnce = true;
        openDialog();
      }, delay * 1000);
    }

    els.closeButtons.forEach(function (btn) {
      btn.addEventListener('click', closeDialog);
    });

    if (els.doneBtn) els.doneBtn.addEventListener('click', closeDialog);
    backdrop.addEventListener('click', function (e) {
      if (e.target === backdrop) closeDialog();
    });
    dialog.addEventListener('click', function (e) {
      e.stopPropagation();
    });
    tab.addEventListener('click', openDialog);

    if (els.spinBtn) els.spinBtn.addEventListener('click', handleSpin);

    if (els.copyBtn) {
      els.copyBtn.addEventListener('click', function () {
        if (!prize) return;
        navigator.clipboard.writeText(prize.code).then(function () {
          els.copyBtn.innerHTML = CHECK_SVG + '<span class="spin-wheel__copy-label">Copiado</span>';
          window.setTimeout(function () {
            els.copyBtn.innerHTML = COPY_SVG + '<span class="spin-wheel__copy-label">Copiar código</span>';
          }, 1800);
        });
      });
    }

    if (els.submitBtn) els.submitBtn.addEventListener('click', handleEmailClaim);

    if (els.emailInput) {
      els.emailInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleEmailClaim();
        }
      });
    }

    if (isCompleted(savedState) && savedState.email) {
      saveCompletion(savedState.email, {
        prizeId: savedState.prizeId,
        label: getPrizeById(savedState.prizeId) ? getPrizeById(savedState.prizeId).label : savedState.prizeId,
        code: savedState.code,
      });
    }

    restoreFromState();
    updateTabVisibility();

    if (!hasSpunBefore(savedState) && !isCompleted(savedState)) {
      if (document.readyState === 'complete') {
        scheduleOpen();
      } else {
        window.addEventListener('load', scheduleOpen, { once: true });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
